import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import AxisSpinner from "../components/AxisSpinner";
import DropDownTrustSelection from "../components/DropDownTrustSelection";
import DropDownRoleSelection from "../components/DropDownRoleSelection";
import DropDownFacilitySelection from "../components/DropDownFacilitySelection";
import DropDownWardSelection from "../components/DropDownWardSelection";
import DropDownCostcentreSelection from "../components/DropDownCostcentreSelection";
import DateTimePicker from "react-datetime-picker";
import { useLocation, useNavigate } from "react-router-dom";
import { addDays } from "date-fns";
import { ButtonModalFormSaveClose } from "../components/ButtonModalSelection";
import { 
  BsCalendarWeek, 
  BsClipboardData, 
  BsBriefcase, 
  BsGeo, 
  BsExclamationTriangle, 
  BsPerson,
  BsBuilding,
  BsMap
} from "react-icons/bs";

const ShiftCreation = ({ shift, onComplete, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [trust, setTrust] = useState(null);
  const [role, setRole] = useState(null);
  const [grade, setGrade] = useState(null);
  const [secondaryRole, setSecondaryRole] = useState(null);
  const [secondaryGrade, setSecondaryGrade] = useState(null);
  const [facility, setFacility] = useState(null);
  const [ward, setWard] = useState(null);
  const [costCentre, setCostCentre] = useState(null);
  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(addDays(new Date(), 1));
  const [priority, setPriority] = useState(null);
  const [skills, setSkills] = useState(null);
  const [status, setStatus] = useState("OPEN");
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [gradeValid, setGradeValid] = useState(false);
  const [startTimeValid, setStartTimeValid] = useState(false);
  const [endTimeValid, setEndTimeValid] = useState(false);
  const [roleValid, setRoleValid] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [requestIdValid, setRequestIdValid] = useState(false);
  const [requestIdRejectReason, setRequestIdRejectReason] = useState(null);
  const [requestIdValidationLoading, setrequestIdValidationLoading] =
    useState(false);
  const [requestIdRequired, setRequestIdRequired] = useState(false);
  const [statusChangeAllowed, setStatusChangeAllowed] = useState(true);
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (shift === null || shift === undefined) return;

    setRequestId(shift?.requestId);
    setSkills(shift?.skills);
    setPriority(shift?.priority);
    setStatus(shift?.status);
    if (shift?.start) setStartTime(new Date(shift?.start));
    if (shift?.end) setEndTime(new Date(shift?.end));
    setRole(shift?.gradeType);
    setGrade(shift?.grade);
    setSecondaryGrade(shift?.secondaryGrade);
    setSecondaryRole(shift?.secondaryGradeType);
    setTrust(shift?.trust);
    setFacility(shift?.facility);
    setWard(shift?.ward);
    setCostCentre(shift?.costCentre);
    setStatus(shift?.status);
    setStatusChangeAllowed(shift?.status === "UNKNOWN");
  }, [shift]);

  useEffect(() => {
    const startValid = startTime !== null;
    setStartTimeValid(startValid);

    if (!startValid) {
      setEndTimeValid(endTime !== null);
    } else {
      if (endTime === null) {
        setEndTimeValid(false);
      } else {
        setEndTimeValid(endTime > startTime);
      }
    }
  }, [startTime, endTime]);

  useEffect(() => {
    validateRequestId();
  }, [requestId]);

  useEffect(() => {
    setRoleValid(role !== null && role !== undefined && role !== "");
  }, [role]);

  useEffect(() => {
    setGradeValid(grade !== null && grade !== undefined && grade !== "");
  }, [grade]);

  useEffect(() => {
    const saveEnabled =
      startTimeValid &&
      endTimeValid &&
      (requestIdRequired ? requestIdValid : true) &&
      roleValid &&
      trust !== null &&
      facility !== null &&
      ward !== null &&
      gradeValid;
    setSaveDisabled(!saveEnabled);
  }, [
    startTimeValid,
    endTimeValid,
    requestIdValid,
    roleValid,
    trust,
    facility,
    ward,
    requestIdRequired,
    gradeValid,
  ]);

  useEffect(() => {
    var required = status === "CONFIRMED" || status === "COMPLETED";
    setRequestIdRequired(required);
  }, [status]);

  const validateRequestId = async () => {
    if (requestId === null || requestId === undefined || requestId === "")
      return;

    setrequestIdValidationLoading(true);
    try {
      var params = {
        request_id: requestId,
      };
      if (shift !== null && shift !== undefined) {
        params["shift_id"] = shift?.id;
        params["shift_table"] = shift?.table;
      }
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/shifts/validate_request_id",
        null,
        config,
      );

      setRequestIdValid(response.data.valid);
      setRequestIdRejectReason(response.data.rejectReason);
      setrequestIdValidationLoading(false);
    } catch (err) {
      setrequestIdValidationLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    
    // Reset error state
    setError(null);
    setShowError(false);
    
    try {
      setLoading(true);

      var update = false;
      var params = {
        status: status,
      };
      if (shift !== null && shift !== undefined) {
        params["shift_id"] = shift?.id;
        update = true;
      }

      const payload = {
        requestId: requestId,
        startTime: startTime?.toISOString(),
        endTime: endTime?.toISOString(),
        priority: priority,
        skills: skills,
        trustId: trust?.id,
        facilityId: facility?.id,
        wardId: ward?.id,
        costCentreId: costCentre?.id,
        grade: grade,
        gradeType: role,
        secondaryGrade: secondaryGrade,
        secondaryGradeType: secondaryRole,
      };

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/shifts/" +
          (update
            ? shift?.table == "shifts"
              ? "update"
              : "archive_update"
            : "create"),
        payload,
        config,
      );
      setLoading(false);

      if (onComplete !== null && onComplete !== undefined)
        onComplete(response.data);

      const newShiftId = response.data.id;
      const newShift =
        response.data.table === "shifts"
          ? "/shifts/view/" + newShiftId
          : "/archiveShifts/view/" + newShiftId;
      navigate(newShift, { replace: true });
    } catch (err) {
      setLoading(false);
      
      // Set error message based on the error
      let errorMessage = "Failed to save shift. Please try again.";
      
      if (err.response) {
        if (err.response.status === 400) {
          errorMessage = "Invalid shift data. Please check all fields and try again.";
        } else if (err.response.status === 401) {
          errorMessage = "Your session has expired. Please log in again.";
        } else if (err.response.status === 403) {
          errorMessage = "You don't have permission to create or modify this shift.";
        } else if (err.response.status === 500) {
          errorMessage = "Server error while processing your request. Please try again later.";
        }
        
        // If we have a more specific error message from the server
        if (err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        }
      }
      
      setError(errorMessage);
      setShowError(true);
      console.error("Error saving shift:", err);
    }
  };

  const requestIdChanged = (value) => {
    var text = value.target.value;
    setRequestId(text.trim());
  };

  const priorityChange = (value) => {
    var text = value.target.value;
    setPriority(text);
  };

  const skillsChange = (value) => {
    var text = value.target.value;
    setSkills(text);
  };

  const statusChange = (value) => {
    var text = value.target.value;
    setStatus(text);
  };

  const gradeChanged = (value) => {
    var text = value.target.value;
    setGrade(text);
  };

  const secondaryGradeChanged = (value) => {
    var text = value.target.value;
    setSecondaryGrade(text);
  };

  return (
    <>
      {loading && (
        <div className="overlay-spinner">
          <div className="text-center">
            <AxisSpinner loading={loading} />
            <div className="mt-2 fw-bold text-axis-offblack">
              {shift ? "Updating" : "Creating"} Shift...
            </div>
          </div>
        </div>
      )}
      
      <Form onSubmit={onSave}>
        {/* Error Alert */}
        {showError && error && (
          <Alert 
            variant="danger" 
            className="mb-4" 
            dismissible 
            onClose={() => setShowError(false)}
          >
            <div className="d-flex align-items-center">
              <BsExclamationTriangle className="me-2" size={20} />
              <div>{error}</div>
            </div>
          </Alert>
        )}
        
        {/* Header */}
        <div className="mb-4">
          <h5 className="mb-0 text-axis-offblack">
            {shift ? "Edit Shift" : "Create New Shift"}
          </h5>
          <div className="text-muted small">
            Fill in the details below to {shift ? "update" : "create"} a shift
          </div>
        </div>
        
        {/* Basic Information Card */}
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center">
            <BsClipboardData className="me-2 text-primary" />
            <span className="fw-bold">Basic Information</span>
          </Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="formRequestId">
              <Form.Label className="fw-semibold">Request ID</Form.Label>
              <div className="input-group">
                <Form.Control
                  type="text"
                  value={requestId}
                  onChange={requestIdChanged}
                  isValid={requestIdValid || !requestIdRequired}
                  isInvalid={!requestIdValid && requestIdRequired}
                  required
                  placeholder="Enter request ID"
                />
                {requestIdValidationLoading && (
                  <div className="input-group-append">
                    <span className="input-group-text bg-light border-0">
                      <AxisSpinner loading={requestIdValidationLoading} />
                    </span>
                  </div>
                )}
              </div>
              <Form.Text className="text-muted">
                Unique identifier for this shift request
              </Form.Text>
              <Form.Control.Feedback type="invalid">
                {requestIdRejectReason || "Request ID is required for confirmed or completed shifts"}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formStatus">
              <Form.Label className="fw-semibold">Status</Form.Label>
              <Form.Select
                value={status}
                onChange={statusChange}
                disabled={!statusChangeAllowed}
                className="mb-2"
              >
                <option value="OPEN">Open</option>
                <option value="PENDING">Pending</option>
                <option value="CONFIRMED">Confirmed</option>
                <option value="COMPLETED">Completed</option>
                <option value="CANCELLED">Cancelled</option>
                <option value="EXPIRED">Expired</option>
                <option value="UNKNOWN">Unknown</option>
              </Form.Select>
              <Form.Text className="text-muted">
                Current status of this shift
              </Form.Text>
            </Form.Group>
          </Card.Body>
        </Card>
        
        {/* Timing Card */}
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center">
            <BsCalendarWeek className="me-2 text-primary" />
            <span className="fw-bold">Shift Timing</span>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formStart">
                  <Form.Label className="fw-semibold">Start Time <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    as={DateTimePicker}
                    onChange={setStartTime}
                    value={startTime}
                    isValid={startTimeValid}
                    isInvalid={!startTimeValid}
                    required
                    className="form-control"
                  />
                  <Form.Text className="text-muted">
                    When the shift begins
                  </Form.Text>
                  <Form.Control.Feedback type="invalid">
                    Please select a valid start time
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formEnd">
                  <Form.Label className="fw-semibold">End Time <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    as={DateTimePicker}
                    onChange={setEndTime}
                    value={endTime}
                    isValid={endTimeValid}
                    isInvalid={!endTimeValid}
                    required
                    className="form-control"
                  />
                  <Form.Text className="text-muted">
                    When the shift ends (must be after start time)
                  </Form.Text>
                  <Form.Control.Feedback type="invalid">
                    Please select a valid end time (after start time)
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        
        {/* Role Information Card */}
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center">
            <BsBriefcase className="me-2 text-primary" />
            <span className="fw-bold">Role Information</span>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formGradeType">
                  <Form.Label className="fw-semibold">Role Type <span className="text-danger">*</span></Form.Label>
                  <DropDownRoleSelection 
                    defaultValue={role} 
                    onSelected={setRole} 
                  />
                  <Form.Text className="text-muted">
                    Primary role type for this shift
                  </Form.Text>
                  {!roleValid && (
                    <div className="text-danger mt-1 small">
                      <BsExclamationTriangle className="me-1" />
                      Role selection is required
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formGrade">
                  <Form.Label className="fw-semibold">Grade <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={grade}
                    onChange={gradeChanged}
                    isValid={gradeValid}
                    isInvalid={!gradeValid}
                    required
                    placeholder="Enter grade"
                  />
                  <Form.Text className="text-muted">
                    Grade level required for this shift
                  </Form.Text>
                  <Form.Control.Feedback type="invalid">
                    Grade is required
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            
            <div className="mb-3 mt-2 border-top pt-3">
              <div className="text-muted mb-2 small fw-semibold">Secondary Role (Optional)</div>
            </div>
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formSecondaryGradeType">
                  <Form.Label className="fw-semibold">Secondary Role Type</Form.Label>
                  <DropDownRoleSelection 
                    onSelected={setSecondaryRole} 
                    defaultValue={secondaryRole}
                  />
                  <Form.Text className="text-muted">
                    Secondary role type if applicable
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formSecondaryGrade">
                  <Form.Label className="fw-semibold">Secondary Grade</Form.Label>
                  <Form.Control
                    type="text"
                    value={secondaryGrade}
                    onChange={secondaryGradeChanged}
                    placeholder="Enter secondary grade"
                  />
                  <Form.Text className="text-muted">
                    Secondary grade level if applicable
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        
        {/* Location Card */}
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center">
            <BsGeo className="me-2 text-primary" />
            <span className="fw-bold">Location</span>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formTrust">
                  <Form.Label className="fw-semibold">Trust <span className="text-danger">*</span></Form.Label>
                  <DropDownTrustSelection
                    defaultValue={trust}
                    onSelected={setTrust}
                  />
                  <Form.Text className="text-muted">
                    The trust this shift belongs to
                  </Form.Text>
                  {!trust && (
                    <div className="text-danger mt-1 small">
                      <BsExclamationTriangle className="me-1" />
                      Trust selection is required
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formFacility">
                  <Form.Label className="fw-semibold">Facility <span className="text-danger">*</span></Form.Label>
                  <DropDownFacilitySelection
                    defaultValue={facility}
                    onSelected={setFacility}
                    trust={trust}
                  />
                  <Form.Text className="text-muted">
                    The healthcare facility for this shift
                  </Form.Text>
                  {!facility && (
                    <div className="text-danger mt-1 small">
                      <BsExclamationTriangle className="me-1" />
                      Facility selection is required
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formWard">
                  <Form.Label className="fw-semibold">Ward <span className="text-danger">*</span></Form.Label>
                  <DropDownWardSelection
                    defaultValue={ward}
                    onSelected={setWard}
                    trust={trust}
                    facility={facility}
                  />
                  <Form.Text className="text-muted">
                    The ward or department for this shift
                  </Form.Text>
                  {!ward && (
                    <div className="text-danger mt-1 small">
                      <BsExclamationTriangle className="me-1" />
                      Ward selection is required
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formCostCentre">
                  <Form.Label className="fw-semibold">Cost Centre</Form.Label>
                  <DropDownCostcentreSelection
                    defaultValue={costCentre}
                    onSelected={setCostCentre}
                    trust={trust}
                    facility={facility}
                  />
                  <Form.Text className="text-muted">
                    Cost centre for billing purposes
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        
        {/* Additional Details Card */}
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center">
            <BsClipboardData className="me-2 text-primary" />
            <span className="fw-bold">Additional Details</span>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formSkills">
                  <Form.Label className="fw-semibold">Required Skills</Form.Label>
                  <Form.Control
                    type="text"
                    value={skills}
                    onChange={skillsChange}
                    placeholder="Enter required skills"
                  />
                  <Form.Text className="text-muted">
                    Specific skills required for this shift
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formPriority">
                  <Form.Label className="fw-semibold">Priority Shift</Form.Label>
                  <Form.Select 
                    onChange={priorityChange}
                    value={priority}
                  >
                    <option value="No">No</option>
                    <option value="Yes">Yes</option>
                  </Form.Select>
                  <Form.Text className="text-muted">
                    Mark as priority if this shift requires urgent attention
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        
        {/* Action Buttons */}
        <div className="text-end mt-4">
          <ButtonModalFormSaveClose
            close={close}
            formSave={onSave}
            saveName={shift ? "Update Shift" : "Create Shift"}
            loading={saveDisabled || loading}
          />
        </div>
      </Form>
    </>
  );
};

export default ShiftCreation;
